var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-avatar",style:({
    background: _vm.randomColor,
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
  })},[_vm._v("\n  "+_vm._s(_vm.first)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }